import React from "react";
import moment from "moment";

const Heartbeat = () => {

    const status = "Active";
    const version = "V1 Demo";
    const releaseTime = "2024-Feb-16"
    const queryTime = moment().format('MMMM Do YYYY, h:mm:ss a');

    return (
        <>
            <div className="text-center" style={{ marginTop: "300px" }}>
                <h1>College Admission Portal - Heartbeat Check</h1>
                <p>Status: {status} &nbsp; Version: {version} &nbsp; Release Time: {releaseTime} &nbsp; Query Time: {queryTime}</p>
            </div>
        </>
    )
}

export default Heartbeat